import locale from "localization/en";

export const expensesColumn = [
  { key: "expenseId", text: locale.expenseId },
  { key: "type", text: locale.typeOfExpense },
  { key: "dateAndTime", text: locale.dateAndTime },
  { key: "amount", text: locale.amount },
  { key: "remarks", text: locale.remarks },
  { key: "receipt", text: locale.receipt },
];
